import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

const LegadoTermometerComp = styled.div`
  * {
    font-family: 'Geist', sans-serif !important;
  }
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .progress-title {
    color: #1e3a8a;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    text-align: left;
  }

  .progress-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 770px;
    margin: 0 auto;
  }

  .progress-bar {
    height: 100px;
    background: white;
    border: 2px solid #1e3a8a;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    ${({ milestonesSize }) => (milestonesSize === 2 ? 'width: 100%;' : 'width: 91%;')}
  }

  .progress-fill {
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
    border-radius: 8px;
    transition: width 0.5s ease-in-out;
  }

  .milestones {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;

    @media (min-width: ${screenSizes.tablet}) {
      ${({ milestonesSize }) =>
        milestonesSize === 2 &&
        `
      justify-content: space-between;
      .milestone:first-child {
        align-items: flex-start;
        text-align: left;
      }
      .milestone:last-child {
        align-items: flex-end;
        text-align: right;
      }
    `}
    }

    .milestone {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      text-align: center;
    }

    .milestone-tick {
      width: 2px;
      height: 20px;
      background: #1e3a8a;
      margin-bottom: 0.5rem;
    }

    .milestone-text {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .milestone-number {
      color: #1e3a8a;
      font-size: 1rem;
      font-weight: 600;
    }

    .milestone-description {
      color: #1e3a8a;
      font-size: 0.75rem;
      font-weight: 400;
      line-height: 1.2;
    }
  }

  @media (max-width: 1050px) {
    padding: 0;
  }

  @media (max-width: ${screenSizes.tablet}) {
    .container {
      gap: 0rem;
    }

    .top-section {
      flex-direction: column;
      text-align: center;
    }

    .main-title {
      font-size: 2rem;
      width: 100%;
    }

    .chair-graphic {
      width: 300px;
      height: 300px;
    }

    .progress-container {
      flex-direction: row;
      align-items: flex-end;
      gap: 10px;
      width: 100%;
      overflow: hidden;
    }

    .progress-bar {
      min-width: 20px;
      width: 20px;
      height: 284px;
      order: 1;
    }

    .progress-fill {
      width: 100%;
      height: 0%;
      background: linear-gradient(180deg, #3b82f6, #60a5fa);
      transition: height 0.5s ease-in-out;
      position: absolute;
      bottom: 0;
    }

    .milestones {
      ${({ milestonesSize }) => (milestonesSize === 2 ? 'gap: 200px;' : 'gap: 0.5rem;')}
      order: 2;
      flex: 1;
      flex-direction: column-reverse;

      .milestone-text {
        width: 300px;
      }

      .milestone {
        flex-direction: row;
        text-align: left;
        gap: 10px;
        min-height: 52px;
        align-items: center;
      }

      .milestone-tick {
        width: 10px;
        height: 2px;
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 0 50px 0 35px;
  }
`;

const LegadoTermometer = (props) => {
  const { progress, title, milestones } = props;

  return (
    <LegadoTermometerComp milestonesSize={milestones.length}>
      <h2 className="progress-title">{title}</h2>
      <div className="progress-container">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{
              width: window.innerWidth <= screenSizes.tablet ? '100%' : `${progress}%`,
              height: window.innerWidth <= screenSizes.tablet ? `${progress}%` : '100%',
            }}
          ></div>
        </div>
        <div className="milestones">
          {milestones.map((milestone, index) => (
            <div className="milestone" key={index}>
              {(!!milestone.number || !!milestone.description) && (
                <div className="milestone-tick"></div>
              )}
              <div className="milestone-text">
                {!!milestone.number && (
                  <span className="milestone-number">{milestone.number} sillas</span>
                )}
                {!!milestone.description && (
                  <span className="milestone-description">{milestone.description}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LegadoTermometerComp>
  );
};

export default LegadoTermometer;
